// todo fix

export const CHAT_CUSTOMER_WIDGET_KEY = 'cnV1VG1Eb0lIY2p4a2J6MUJNOVVPZ1JUejZ0ZVpSTHdCQUZJcjNXTEEzWT0=';

export const STRINGEE_CLIENT_TOKEN =
    "eyJjdHkiOiJzdHJpbmdlZS1hcGk7dj0xIiwidHlwIjoiSldUIiwiYWxnIjoiSFMyNTYifQ.eyJqdGkiOiJTSy4wLnJ2N0ZQRndN" +
    "UXVjajVEVjFYOEJ3bUtMdXFadExEMURyLTE2OTgwMzYzMDAiLCJpc3MiOiJTSy4wLnJ2N0ZQRndNUXVjajVEVjFYOEJ3bUtMdXFa" +
    "dExEMURyIiwiZXhwIjoxNzAwNjI4MzAwLCJ1c2VySWQiOiJBQ1hLSFpXOTYzIn0.V145PIwl013-d_kUacRslK7RQ6kkVlTuZpct" +
    "CGSfyLY";
